/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

// @flow
import type { Element } from 'react';

import React from 'react';
import { Col, Form, Row } from 'reactstrap';
import { LAT, LNG } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import NextButton from '#components/pages/Models/Model/sections/support/buttons/NextButton.jsx';
import BackButton from '#components/pages/Models/Model/sections/support/buttons/BackButton.jsx';
import ContinueToNextSectionGroupButton from '#components/pages/Models/Model/sections/support/buttons/ContinueToNextSectionGroupButton/index.jsx';
import SubmitButton from '#components/pages/Models/Model/sections/support/buttons/ModelFormSectionSubmitButton/index.jsx';
import SiteLocationLockNote from '#components/pages/Models/Model/sections/support/SiteLocationLockNote/index.jsx';
import Tip from '#components/support/tooltips/Tip/index.jsx';
import { Field, Fieldset, FormGroup } from '#components/pages/Models/Model/support/form/index.js';
import SiteMap from './SiteMap/index.js';

type Props = {|
  fieldsByName: Object,
  form: string,
  group: string,
  handleSubmit: Function,
  heading: string,
  isLastInGroup?: boolean,
  isReadOnly?: boolean,
  modelId: string,
  modelType: number,
  onBack: Function,
  onNext: Function,
|};

const SiteCoordinatesSection = ({
  fieldsByName,
  form,
  group,
  handleSubmit,
  heading,
  isLastInGroup = false,
  isReadOnly = false,
  modelId,
  modelType,
  onBack,
  onNext,
}: Props): Element<'div'> => (
  <div>
    <h2>{heading}</h2>
    <Form noValidate onSubmit={isLastInGroup ? handleSubmit : undefined}>
      <Fieldset>
        <legend>
          Site Coordinates <Tip tipId="siteCoordinates" />
        </legend>
        <Row>
          <Col lg="3" md="4">
            <FormGroup form={form} fields={[LAT]}>
              <Field field={fieldsByName[LAT]} />
            </FormGroup>
            <FormGroup form={form} fields={[LNG]}>
              <Field field={fieldsByName[LNG]} />
            </FormGroup>
            <SiteLocationLockNote isReadOnly={isReadOnly} />
          </Col>
          <Col lg="9" md="8">
            <SiteMap form={form} draggable={!isReadOnly} />
          </Col>
        </Row>
      </Fieldset>
      <BackButton onClick={onBack} />
      {isLastInGroup ? (
        <>
          <SubmitButton modelType={modelType} modelId={modelId} />
          <ContinueToNextSectionGroupButton group={group} modelType={modelType} onClick={onNext} />
        </>
      ) : (
        <NextButton onClick={onNext} />
      )}
    </Form>
  </div>
);

export default SiteCoordinatesSection;
